import type {ReactNode} from "react";

import {cn} from "@project/design-system-web";

import {PageContainer} from "./page-container";

export function EntityLayout({children, className}: {children: ReactNode; className?: string}) {
  return (
    <PageContainer className={cn("flex-col @2xl:flex-row", className)}>{children}</PageContainer>
  );
}

function Sidebar({children, className}: {children: ReactNode; className?: string}) {
  return (
    <div
      className={cn(
        "hidden h-full min-h-0 w-full flex-col @2xl:flex @2xl:w-2/5 @2xl:max-w-lg @2xl:min-w-75",
        className,
      )}
    >
      {children}
    </div>
  );
}

function Main({children, className}: {children: ReactNode; className?: string}) {
  return (
    <div className={cn("flex h-full min-h-0 w-full flex-1 flex-col", className)}>{children}</div>
  );
}

function DesktopNav({children, className}: {children: ReactNode; className?: string}) {
  return <div className={cn("hidden @2xl:block", className)}>{children}</div>;
}

function MobileNav({children, className}: {children: ReactNode; className?: string}) {
  return <div className={cn("w-full @2xl:hidden", className)}>{children}</div>;
}

function Content({children, className}: {children: ReactNode; className?: string}) {
  return (
    <div className={cn("-mx-1 flex flex-1 flex-col overflow-auto px-1 pt-4 @2xl:pt-6", className)}>
      {children}
    </div>
  );
}

EntityLayout.Sidebar = Sidebar;
EntityLayout.Main = Main;
EntityLayout.DesktopNav = DesktopNav;
EntityLayout.MobileNav = MobileNav;
EntityLayout.Content = Content;
